/*
Runs on every page.
*/
import {AccessibleDropdown} from '../../lib/components/AccessibleDropdown';
import {MobileMenu} from '../../lib/components/MobileMenu';
import {Gallery} from '../../lib/components/gallery';
import {ButtonGroup} from '../../lib/components/ButtonGroup';
import {ContentSwitcher} from '../../lib/components/ContentSwitcher';
import {eventEmitter} from '../../lib/components/EventEmitter';
import {getBreakpointSize, a11yTest} from '../../lib/js/tools';
import {Accordion} from '../../lib/components/Accordion';
import {Slider} from '../../lib/components/Slider';
import {Modal} from '../../lib/components/modal';
import {ImageRotator} from '../../lib/components/image-rotator';
import {ItemRotator} from '../../lib/components/item-rotator';
import { AnimatedText } from '../../lib/components/AnimatedText';
import { Marquee } from '../../lib/components/Marquee';
import { PageScrollWatcher } from '../../lib/components/PageScrollWatcher';
import { ResponsiveLayoutWatcher } from '../../lib/components/ResponsiveLayoutWatcher';
import { FilteredItems } from '../../lib/components/FilteredItems';
import * as Router from '../../lib/components/Router';

import * as AdminPage from './pages/admin';
import * as HomePage from './pages/home';
import * as DemoPage from './pages/demo';


function disableClickFocus() {
  /*
  Because focus outlines don't look good for clicks.
  */
  const elements = document.querySelectorAll('a, button, [tabindex]');
  for (const element of elements) {
    element?.addEventListener('mousedown', (event) => {
      event.preventDefault();
    });
  }
}

function createMobileMenu() {
  const element = document.querySelector('.jk-mobile-menu');
  const menu = new MobileMenu({
    element,
    onToggle({isOpen}) {
      // must scroll to top of page for tablet devices to align with header
      if (isOpen && getBreakpointSize() === 'M') {
        document.documentElement.scrollTop = 0;
      }
    },
  });
  console.log(menu);
}

function createAccessibilityDropdowns() {
  const elements = document.querySelectorAll('nav .has-children');
  for (const element of elements) {
    const dropdown = new AccessibleDropdown(element);
    console.log(dropdown);
  }
}

function createGalleries() {
  const elements = document.querySelectorAll('.jk-gallery');
  for (const element of elements) {
    const gallery = new Gallery(element);
    console.log(gallery);
  }
}

function createButtonGroups() {
  const elements = document.querySelectorAll('.jk-button-group');
  for (const element of elements) {
    const buttonGroup = new ButtonGroup({
      element,
      onSelect(buttonId) {
        eventEmitter.emit('button-group:select', {buttonId: buttonId});
      }
    });
    console.log(buttonGroup);
  }
}

function createContentSwitchers() {
  const contentSwitchers = [];
  const elements = document.querySelectorAll('.jk-content-switcher');
  for (const element of elements) {
    const contentSwitcher = new ContentSwitcher(element);
    contentSwitchers.push(contentSwitcher);
  }
  console.log(contentSwitchers);

  eventEmitter.on('image-rotator:onRotateHint', ({ message }) => {
    const contentSwitcher = contentSwitchers[0];

    contentSwitcher.elements.root.classList.add('fade-out');
  });

  eventEmitter.on('image-rotator:onRotate', ({message}) => {
    const contentSwitcher = contentSwitchers[0];
    const currentItem = contentSwitcher.selectedItem;
    let nextItem = currentItem.nextElementSibling;

    if (!nextItem) {
      const firstItem = contentSwitcher.elements.items[0];

      nextItem = firstItem;
    }

    const nextId = nextItem.dataset.id;

    contentSwitcher.elements.root.classList.remove('fade-out');
    contentSwitchers[0].show(nextId);
  });
}

function createAccordions() {
  const components = [];
  const elements = document.querySelectorAll('.jk-accordion');
  for (const element of elements) {
    const component = new Accordion(element);
    components.push(component);
  }
  console.log(components);
}

function createSliders() {
  const components = [];
  const elements = document.querySelectorAll('.jk-slider');
  for (const element of elements) {
    const component = new Slider(element);
    components.push(component);
  }
  console.log(components);
}

function createModals() {
  const components = [];
  const elements = document.querySelectorAll('.jk-modal');
  for (const element of elements) {
    const component = new Modal(element);
    components.push(component);
  }
  console.log(components);
}

function createImageRotators() {
  const components = [];
  const elements = document.querySelectorAll('.jk-image-rotator');
  for (const element of elements) {
    const component = new ImageRotator(element, {
      onRotateHint: (component) => {
        console.log('onRotateHint', component);
        eventEmitter.emit('image-rotator:onRotateHint');
      },
      onRotate: (component) => {
        console.log('onRotate', component);
        eventEmitter.emit('image-rotator:onRotate');
      }
    });
    components.push(component);
  }
  console.log(components);
}

function createItemRotators() {
  const components = [];
  const elements = document.querySelectorAll('.jk-item-rotator');
  for (const element of elements) {
    const component = new ItemRotator(element, {
      renderItem: ({ text } = data) => {
        return `
          <div class='item'>
            ${text}
          </div>
        `;
      },
    });
    components.push(component);
  }
  console.log(components);
}

function createAnimatedText() {
  const components = [];
  const elements = document.querySelectorAll('.jk-animated-text');
  for (const element of elements) {
    const component = new AnimatedText(element, {
      delay: .03
    });
    components.push(component);
  }
  console.log(components);
}

function createMarquees() {
  const components = [];
  const elements = document.querySelectorAll('.jk-marquee');

  components.push(
    new Marquee(elements[0], {
      direction: 'right',
    })
  );
  components.push(
    new Marquee(elements[1], {
      direction: 'down',
    })
  );
  console.log(components);
}

function createFilteredItems() {
  const components = [];
  const elements = document.querySelectorAll('.jk-filtered-items');

  for (const element of elements) {
    components.push(
      new FilteredItems(element, {
      })
    );
  }

  console.log(components);
}

function runRouter() {
  const routes = {
    '^/wp-admin/': AdminPage,
    '^/$': HomePage,
    '^/demo': DemoPage,
  };

  Router.run(routes);
}

function runScrollWatcher() {
  PageScrollWatcher.run();
  PageScrollWatcher.onScroll(() => {
    // Easily animate by element's position on the screen by using a paused css animation
    // and setting the current frame based on the scroll percent.
    {
      const target = document.querySelector('#scroll-target-1 .box');

      if (PageScrollWatcher.isVisible(target)) {
        const scrollPercent = PageScrollWatcher.getScrollPercent(target, {
          offsetTop: .25,
          offsetBottom: .25,
        });
        const animationDuration = parseInt(getComputedStyle(target).animationDuration);
        const time = animationDuration * scrollPercent;

        target.style.animationDelay = `-${time}s`;
      }
    }
    {
      const target = document.querySelector('#scroll-target-2 .box');

      if (PageScrollWatcher.isVisible(target)) {
        const scrollPercent = PageScrollWatcher.getScrollPercent(target);
        const animationDuration = parseInt(getComputedStyle(target).animationDuration);
        const time = animationDuration * scrollPercent;

        target.style.animationDelay = `-${time}s`;
      }
    }
    {
      const target = document.querySelector('#scroll-target-3 .box');

      if (PageScrollWatcher.isVisible(target)) {
        const scrollPercent = PageScrollWatcher.getScrollPercent(target);
        const animationDuration = parseInt(getComputedStyle(target).animationDuration);
        const time = animationDuration * scrollPercent;

        target.style.animationDelay = `-${time}s`;
      }
    }
  });
}

function runResponsiveLayoutWatcher() {
  ResponsiveLayoutWatcher.onChange(layout => {
    const target = document.querySelector(`.demo-responsive-layout-watcher .${layout.toLowerCase()}-breakpoint`);

    if (target) {
      for (const element of document.querySelectorAll(`.demo-responsive-layout-watcher > div`)) {
        element.style.display = 'none';
      }

      target.style.display = 'block';
    }
  });
  ResponsiveLayoutWatcher.run();
}

/*
Global components should be created first,
because later scripts depend on their existance (like disableClickFocus).
*/
createMobileMenu();
createAccessibilityDropdowns();
createGalleries();
createButtonGroups();
createContentSwitchers();
createAccordions();
createSliders();
createModals();
createImageRotators();
createItemRotators();
createAnimatedText();
createMarquees();
createFilteredItems();

// fun AFTER creating components
runRouter();
runScrollWatcher();
runResponsiveLayoutWatcher();
disableClickFocus();

window.a11yTest = a11yTest;
